var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3.64,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.454545,
    y: 0.454545,
    width: 39.0909,
    height: 39.0909,
    rx: 3.18182,
    stroke: "#616161",
    strokeWidth: 0.909091
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10403_408)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8193 13.182C11.8193 12.4289 12.4299 11.8184 13.183 11.8184H26.8193C27.5724 11.8184 28.183 12.4289 28.183 13.182V15.0782C28.183 15.5604 27.9914 16.0228 27.6504 16.3638L22.7284 21.2858V28.0349C22.7284 28.7783 21.9462 29.2618 21.2812 28.9294L17.902 27.2397C17.5171 27.0473 17.2739 26.6538 17.2739 26.2234V21.2858L12.3519 16.3638C12.0109 16.0228 11.8193 15.5604 11.8193 15.0782V13.182ZM13.6375 13.6365V15.0782L18.6927 20.1333C18.9484 20.3891 19.0921 20.7359 19.0921 21.0975V25.802L20.9102 26.7111V21.0975C20.9102 20.7359 21.0539 20.3891 21.3096 20.1333L26.3648 15.0782V13.6365H13.6375Z",
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10403_408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8182,
    height: 21.8182,
    fill: "white",
    transform: "translate(9.0918 9.09082)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.79991415ae42c96d0f71cac4e98bf0ac.svg";
export { ForwardRef as ReactComponent };